import React from 'react'

const BasicDropDown = ({value, onSelect, items, disable, size, name}) => {
  console.log('value', value);
  return (
    <select
      name={name}
      disabled={disable}
      placeholder="Select Vehicle"
      onChange={(e)=>onSelect(e, 'account')}
      className={
        `rounded-md ${disable ? 'text-gray-900': 'border border-gray-400'} w-full py-2 px-4 bg-white disabled:border disabled:border-gray-700 shadow-sm focus:outline-none ${size === 'small' ? 'text-sm my-auto col-span-2  font-medium text-gray-500':'text-base text-gray-800'}`
      }
      value={value}
    >
      <option value="" disabled selected>Select option</option>
      {items.map((item)=>{
        return <option value={item}>{item}</option>
      })}
    </select>
  )
}

export default BasicDropDown